import {
  MULTIPLE_CAMERA_STATUSES_CHANGE,
  MIXER_ATTENDEES_CAMERA_STATUS_CHANGE
} from 'store/eventConstants';
import updateProgramByCameraSource from 'actions/Broadcast/program/updateProgramByCameraSource';
import { BROADCAST_SET_MULTIPLE_DESIRED_ATTENDEE_CAMERA_STATUSES } from 'actions/Types';

/**
 * @param {Object} attendeeCameraStatuses a map of attendeeIds and their corresponding mute status. { attendeeId: true}
 */
export default attendeeCameraStatuses => {
  return (dispatch, getState, socket) => {
    const { broadcast, program, attendeeCameraStatus } = getState();
    const { _id: broadcastId } = broadcast || {};
    const action = {
      type: BROADCAST_SET_MULTIPLE_DESIRED_ATTENDEE_CAMERA_STATUSES,
      request: async () => {
        const socketPayload = {
          attendeeCameraStatuses,
          broadcastId
        };

        socket.emit(MULTIPLE_CAMERA_STATUSES_CHANGE, socketPayload);

        socket.emit(MIXER_ATTENDEES_CAMERA_STATUS_CHANGE, {
          broadcastId,
          attendeesCameraStatus: {
            ...attendeeCameraStatus,
            ...attendeeCameraStatuses
          }
        });

        return Object.create(null);
      },
      payload: attendeeCameraStatuses
    };

    dispatch(action);

    const attendeeIdsMap = Object.keys(attendeeCameraStatus).reduce(
      (accumulator, attendeeId) => {
        accumulator[attendeeId] = attendeeId;
        return accumulator;
      },
      {}
    );

    if (program) {
      dispatch(updateProgramByCameraSource(attendeeIdsMap));
    }
  };
};
